import { connect, ConnectOptions, LocalTrack, Room, RemoteParticipant } from 'twilio-video';
import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject, Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment'
interface AuthToken {
    token: string;
}

export interface NamedRoom {
    id: string;
    name: string;
    maxParticipants?: number;
    participantCount: number;
}

export type Rooms = NamedRoom[];

@Injectable()
export class VideoChatService implements OnDestroy {
    $roomsUpdated: Observable<boolean>;

    private roomBroadcast = new ReplaySubject<boolean>();

    private userName = new Subject();
    $userName = this.userName.asObservable();

    constructor(private readonly http: HttpClient) {
        this.$roomsUpdated = this.roomBroadcast.asObservable();
    }

    ngOnDestroy(): void {
        if (this.roomBroadcast) {
            this.roomBroadcast.unsubscribe();
        }
    }

    private async getAuthToken(userName, roomName) {
        const auth =
            await this.http
                .get<AuthToken>(`${environment.restAPIUrl}/api/video/token/${roomName}/${userName}`)
                .toPromise();

        return auth.token;
    }

    getAllRooms() {
        return this.http
            .get<Rooms>(`${environment.restAPIUrl}/api/video/rooms`)
            .toPromise();
    }
  //Join  room 
    async joinOrCreateRoom(name: string, tracks: LocalTrack[], userName) {
        let room: Room = null;
        try {
            const token = await this.getAuthToken(userName, name);

            room =
                await connect(
                    token, {
                        name,
                        userName,
                        tracks,
                        dominantSpeaker: true
                    } as ConnectOptions);

        } catch (error) {


        } finally {
            if (room) {
                this.roomBroadcast.next(true);
            }
        }
        return room;
    }

    sendUserName(userName: string) {
        this.userName.next(userName);
    }

    nudge() {
        this.roomBroadcast.next(true);
    }
}